import { hasRule, espaceRCRules as rules } from "@/utils/rulesHelper"

function buildMenu() {
  let children = []

  children.push({ name: 'Fiches Niv.2 en cours', url: '/espace-rc/fiches-niveau2', icon: 'fa fa-address-card-o' })

  children.push({ name: 'Recherche Fiches', url: '/espace-rc/fiches-niv2/liste', icon: 'fa fa-search' })

  if (hasRule(rules.CAN_MANAGE_DOMAINE_EQUIPE)) {
    children.push({ name: 'Domaines/Equipes', url: '/espace-rc/fiches/domaines/list', icon: 'fa fa-users' })
  }

  // if (hasRule(rules.CAN_MANAGE_FICHES_NIV2)) {
  //   children.push({ name: 'Fiches Niv.2 en cours', url: '/espace-rc/fiches-niveau2', icon: 'fa fa-users' })
  // }

  // if (hasRule(rules.CAN_ACCESS_FICHES_NIV2)) {
  //   children.push({ name: 'Recherche Fiches', url: '/espace-rc/fiches-niv2/liste', icon: 'fa fa-user' })
  // }
  // children.push({ name: 'Domaines/Equipes', url: '/espace-rc/fiches/domaines/list', icon: 'fa fa-server' })
  // children.push({ name: 'Domaine / Equipe', url: '/espace-rc/fiches/domaine-equipe', icon: 'fa fa-cog' })

  return children
}

let menu = {
  items: buildMenu()
}
export default menu
